export default __webpack_public_path__ + "static/media/MeteoJK.36500f37.png";